<template>
  <transition name="slide">
    <div class="bg-yellow-500/90 text-white py-2 px-4 w-full rounded-lg shadow-lg cursor-pointer">
      <h1>{{ notification.title }}</h1>
      <span class="text-sm mt-2">{{ notification.body }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VNotification",
  props: ['notification']
}
</script>

<style scoped>

</style>